export interface Vec3 {
  x: number;
  y: number;
  z: number;
}

export const v3 = (x = 0, y = 0, z = 0): Vec3 => ({ x, y, z });

export const clamp = (v: number, min: number, max: number): number => (v < min ? min : v > max ? max : v);

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

export const dist2D = (ax: number, az: number, bx: number, bz: number): number => Math.hypot(ax - bx, az - bz);

export const dist3 = (a: Vec3, b: Vec3): number => Math.hypot(a.x - b.x, a.y - b.y, a.z - b.z);

/** Normaliza un ángulo al rango (-PI, PI]. */
export function wrapAngle(a: number): number {
  a = (a + Math.PI) % (Math.PI * 2);
  if (a < 0) a += Math.PI * 2;
  return a - Math.PI;
}

/** Interpola ángulos por el camino más corto. */
export const angleLerp = (a: number, b: number, t: number): number => a + wrapAngle(b - a) * t;

export const round2 = (n: number): number => Math.round(n * 100) / 100;

/** Mueve un vector 2D hacia un objetivo con un paso máximo. */
export function moveTowards2(
  cx: number,
  cz: number,
  tx: number,
  tz: number,
  maxDelta: number,
): [number, number] {
  const dx = tx - cx;
  const dz = tz - cz;
  const d = Math.hypot(dx, dz);
  if (d <= maxDelta || d === 0) return [tx, tz];
  return [cx + (dx / d) * maxDelta, cz + (dz / d) * maxDelta];
}

/** Generador pseudoaleatorio determinista (mulberry32) para reproducir eventos en tests. */
export function createRng(seed: number): () => number {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
